module.exports = __webpack_public_path__ + "img/news-logo-hover.bbac2adb.png";